// Firefox no deja estilar las flechas de input[type=number]. Se ocultan por CSS (index.css) y aquí
// se muestra un único par de chevrons verdes flotante sobre el input que tiene el ratón o el foco.
// No toca el DOM de React: el control vive en document.body y cambia el valor con stepUp/stepDown.

const chevron = (path: string) =>
  `<svg width="12" height="8" viewBox="0 0 12 8" fill="none" stroke="#00ab84" stroke-width="1.8" ` +
  `stroke-linecap="round" stroke-linejoin="round"><path d="${path}"/></svg>`;

const isNumberInput = (el: EventTarget | null): el is HTMLInputElement =>
  el instanceof HTMLInputElement && el.type === 'number' && !el.disabled && !el.readOnly;

export const initNumberSpinners = () => {
  if (typeof navigator === 'undefined' || !/firefox/i.test(navigator.userAgent)) return;

  const box = document.createElement('div');
  box.style.cssText =
    'position:fixed;display:none;flex-direction:column;width:18px;z-index:2147483000;' +
    'background:var(--bg-secondary,#fff);';

  const makeButton = (path: string, direction: 'up' | 'down') => {
    const button = document.createElement('button');
    button.type = 'button';
    button.tabIndex = -1;
    button.setAttribute('aria-label', direction === 'up' ? 'Aumentar' : 'Disminuir');
    button.style.cssText =
      'flex:1;display:flex;align-items:center;justify-content:center;padding:0;margin:0;' +
      'border:0;background:transparent;cursor:pointer;';
    button.innerHTML = chevron(path);
    button.addEventListener('click', () => step(direction));
    return button;
  };

  box.appendChild(makeButton('M2 6.5l4-4 4 4', 'up'));
  box.appendChild(makeButton('M2 1.5l4 4 4-4', 'down'));
  // mousedown con preventDefault: el input no pierde el foco al pulsar un chevron
  box.addEventListener('mousedown', e => e.preventDefault());
  document.body.appendChild(box);

  let current: HTMLInputElement | null = null;
  let hideTimer: number | undefined;

  const place = () => {
    if (!current) return;
    const r = current.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) { hide(); return; }
    box.style.left = `${r.right - 19}px`;
    box.style.top = `${r.top + 1}px`;
    box.style.height = `${r.height - 2}px`;
    box.style.display = 'flex';
  };

  const hide = () => {
    current = null;
    box.style.display = 'none';
  };

  const show = (input: HTMLInputElement) => {
    window.clearTimeout(hideTimer);
    current = input;
    place();
  };

  const scheduleHide = () => {
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(() => {
      if (current && current !== document.activeElement && !box.matches(':hover')) hide();
    }, 150);
  };

  const step = (direction: 'up' | 'down') => {
    const input = current;
    if (!input) return;
    try {
      if (direction === 'up') input.stepUp(); else input.stepDown();
    } catch (_) {
      return; // step="any" u otro valor que stepUp no admite
    }
    // React escucha 'input'; 'change' cubre a los listeners nativos
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.focus();
  };

  document.addEventListener('mouseover', e => {
    if (isNumberInput(e.target)) show(e.target);
    else if (!box.contains(e.target as Node)) scheduleHide();
  });
  document.addEventListener('focusin', e => { if (isNumberInput(e.target)) show(e.target); });
  document.addEventListener('focusout', scheduleHide);
  window.addEventListener('scroll', place, true);
  window.addEventListener('resize', place);
};
